import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  {
    right: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s8,
      flexShrink: 0, // Never shrink - navigation must stay visible
    },
    // Mobile-only wrapper - hides the Generations InlineButton on desktop via CSS
    generationsButton: {
      display: 'inline-flex',
      // Hide on desktop - CSS handles responsive
      [`@media (min-width: ${Breakpoints.sm}px)`]: {
        display: 'none',
      },
    },
    settingsWrapper: {
      position: 'relative',
    },
    iconButton: {
      width: Spacings.s40,
      height: Spacings.s40,
      flex: `0 0 ${Spacings.s40}`,
      borderRadius: CornerRadius.circle,
    },
  },
  { name: 'header-right' }
);

export default useStyles;
